import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
// import DownloadPage from "./pages/DownloadPage";
import AppLayout from "./components/AppLayout";
import { ThemeContext } from "./context/ThemeContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { Spinner } from "react-bootstrap";
import SignInContainer from "./components/SignInContainer";
import { useAuthActions } from "./hooks/useAuthActions";
import "./styles/LastUploadedFile.css";

function App() {
  const [theme, setTheme] = useState("dark");
  const { auth, signOutRedirect } = useAuthActions();

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) setTheme(savedTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  if (auth.isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant={theme === "dark" ? "light" : "dark"} />
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="text-center mt-5 text-danger">
        Encountered error: {auth.error.message}
      </div>
    );
  }

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <Router>
        <AppLayout
          signOut={signOutRedirect}
          isAuthenticated={auth.isAuthenticated}
        >
          <Routes>
            {/* Root route */}
            <Route
              path="/"
              element={
                auth.isAuthenticated ? (
                  <LandingPage />
                ) : (
                  <SignInContainer onSignIn={() => auth.signinRedirect()} />
                )
              }
            />
            {/* Catch-all route for undefined paths */}
            <Route path="*" element={<Navigate to="/" replace />} />

            {/* Download route with inline redirect if not authenticated */}
            {/* <Route
              path="/download"
              element={<DownloadPage />}
            /> */}
          </Routes>
        </AppLayout>
      </Router>
    </ThemeContext.Provider>
  );
}

export default App;